import { createLink, type LinkProps as TLinkProps } from "@tanstack/react-router";
import MuiLink, { type LinkProps as MuiLinkProps } from "@mui/material/Link";


export type RouterLinkProps = { tab?: boolean } & TLinkProps;
export type LinkProps = RouterLinkProps & MuiLinkProps;

const CustomLink = createLink(MuiLink);

export default function Link({ tab, ...props }: LinkProps) {
	return <CustomLink underline="none" target={tab ? "_blank" : undefined} rel="noopener noreferer" {...props} />;
}